import dotenv from 'dotenv';

dotenv.config({ path: '../../.env' });

const TOKEN_KEY = process.env.REACT_APP_USER_TOKEN_KEY || 'user_token';
const REFRESH_TOKEN_KEY = process.env.REACT_APP_USER_REFRESH_TOKEN_KEY || 'refresh_token';
const SERVER_API = process.env.REACT_APP_API_SERVER || 'http://localhost:8000';
const IS_FIRST_VISIT = 'first_visit';
const THEME = 'theme'
const BASE_URL = process.env.REACT_APP_BASE_URL || 'http://localhost:3000'
const FIREBASE = require('../firebase.config').default[
	process.env.REACT_APP_PLATFORM ? process.env.REACT_APP_PLATFORM : 'am'
]

export default {
	TOKEN_KEY,
	REFRESH_TOKEN_KEY,
	SERVER_API,
	IS_FIRST_VISIT,
	THEME,
	BASE_URL,
	FIREBASE
};
